export default "__VITE_ASSET__BpgIOEpy__"